import NavBar from "../components/navbar/navbar";
import Footer from "../components/footer";
import { Outlet } from "react-router-dom";
import CookieConsentForm from "../components/CookieConsentForm";

const Layout = () => {
  return (
    <>
      <div className="m-auto overflow-hidden px-0 antialiased">
        <NavBar />
        <CookieConsentForm />
        <div className="mt-[95.0px]">
          <Outlet />
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Layout;
